import {
    CREATE_POLICIES_MANUALS,
    CREATE_POLICIES_MANUALS_ITEM,
    DELETE_POLICIES_MANUALS,
    DELETE_POLICIES_MANUALS_ITEM,
    GET_POLICIES_MANUALS,
    GET_POLICIES_MANUALS_ITEM,
    UPDATE_POLICIES_MANUALS,
    UPDATE_POLICIES_MANUALS_ITEM,
} from "shared/constants/ActionTypes";

const initialState = {
    policyList: [],
    policyItem: [],
};
export const policyReducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case GET_POLICIES_MANUALS:
            return {
                ...state,
                policyList: payload,
            };
        case CREATE_POLICIES_MANUALS:
            return {
                ...state,
                policyList:
                    payload !== null
                        ? [payload, ...(state.policyList || [])]
                        : state.policyList,
            };
        case UPDATE_POLICIES_MANUALS:
            return {
                ...state,
                policyList: [
                    ...(state.policyList || []).map((item) =>
                        item.id === payload.id ? { ...payload.data } : item
                    ),
                ],
            };
        case DELETE_POLICIES_MANUALS:
            return {
                ...state,
                policyList: [
                    ...(state.policyList || []).filter(
                        (item) => item.id !== payload.id
                    ),
                ],
            };
        case GET_POLICIES_MANUALS_ITEM:
            return {
                ...state,
                policyItem: payload,
            };
        case CREATE_POLICIES_MANUALS_ITEM:
            return {
                ...state,
                policyItem:
                    payload !== null
                        ? [payload, ...(state.policyItem || [])]
                        : state.policyItem,
            };
        case UPDATE_POLICIES_MANUALS_ITEM:
            return {
                ...state,
                policyItem: [
                    ...(state.policyItem || []).map((item) =>
                        item.id === payload.id ? { ...payload.data } : item
                    ),
                ],
            };
        case DELETE_POLICIES_MANUALS_ITEM: {
            return {
                ...state,
                policyItem: [
                    ...(state.policyItem || []).filter(
                        (item) => item.id !== payload.id
                    ),
                ],
            };
        }
        default:
            return state;
    }
};
